export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const DEFAULT_CONTENT = {
  brand: {
    logo_url: "/bvc-logo.png",
    area_text: "Servicing Maroubra & greater Sydney",
    hours_text: "Mon–Sat · 7am–6pm",
  },
  contact: {
    phone: "0483 880 650",
    phone_href: "tel:0483880650",
    email: "hello@bvcpropertyservices.com.au",
    email_href: "mailto:hello@bvcpropertyservices.com.au",
  },
  navigation: { services: "Services", approach: "Approach", area: "Service area", contact: "Contact", quote: "Get a quote" },
  service_link_text: "Enquire",
  form: {
    name_label: "Your name",
    email_label: "Email",
    phone_label: "Phone",
    property_label: "Property type",
    message_label: "How can we help?",
    submit_label: "Send enquiry",
    sending_label: "Sending…",
    property_options: ["Commercial", "Residential", "Rural", "Real estate / strata"],
  },
  hero: {
    eyebrow: "Property care, done properly",
    title_lines: ["Good grounds.", "Great first", "impressions."],
    lead: "Reliable property maintenance for the people who look after Sydney’s homes, businesses and land.",
    primary_cta: "Request a quote",
    secondary_cta: "Call 0483 880 650",
    image: "https://images.unsplash.com/photo-1704457030816-6b9b08d1bb08?crop=entropy&cs=srgb&fm=jpg&q=85",
    badge_title: "Landscaping with purpose",
    badge_text: "Residential · Commercial · Rural",
    note: "Local, dependable & ready to help",
    note_highlight: "Maroubra & Sydney-wide",
  },
  marquee_items: ["Mowing", "Edging", "Brush cutting", "Hedging", "Gardening", "Weed control", "Site clearing", "Green waste removal"],
  manifesto: [
    { number: "01", title: "Arrive prepared", text: "Every visit starts with a clear understanding of the property, the standard expected and the finish required." },
    { number: "02", title: "Work with care", text: "From compact residential lawns to commercial frontages and rural blocks, we match the equipment and approach to the site." },
    { number: "03", title: "Leave it better", text: "Clean edges, tidy paths, controlled weeds and green waste removed — the details are the difference." },
  ],
  services: [
    { title: "Mowing", description: "Push or zero-turn mowing, finished with a crisp, even cut.", image: "https://images.unsplash.com/photo-1630311853242-edd0c07766c0?crop=entropy&cs=srgb&fm=jpg&q=85" },
    { title: "Edging", description: "Sharp, clean lines that make every property frontage look cared for.", image: "" },
    { title: "Brush cutting", description: "Regain control of overgrown areas, blocks and rural properties.", image: "" },
    { title: "Hedging", description: "Neat, healthy hedges shaped to suit your property and surrounds.", image: "https://images.unsplash.com/photo-1734079692079-172d8243ebd3?crop=entropy&cs=srgb&fm=jpg&q=85" },
    { title: "Gardening", description: "Practical garden care that keeps outdoor spaces welcoming year-round.", image: "" },
    { title: "Weed control", description: "Targeted maintenance to keep weeds from taking over garden beds.", image: "" },
    { title: "Site clearing", description: "Clear the way for a sale, build, renovation or a fresh start.", image: "" },
    { title: "Green waste removal", description: "A tidy finish with green waste removed and your site left clean.", image: "" },
  ],
  approach: {
    eyebrow: "A considered approach",
    title_lines: ["One less thing", "to manage."],
    text: "Property care should feel simple. We show up when we say we will, communicate clearly and leave your grounds looking their best.",
    bullets: ["Consistent, reliable service", "Clear quotes, no surprises", "A tidy finish, every visit"],
    image: "https://images.unsplash.com/photo-1778508882767-757ca196b987?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  area: {
    eyebrow: "Where we work",
    title_lines: ["Rooted in", "Maroubra."],
    text: "We’re local to Maroubra and proudly service properties across Sydney’s eastern suburbs and beyond.",
    suburbs: ["Maroubra", "Coogee", "Randwick", "Malabar", "South Coogee", "Eastern Suburbs", "Greater Sydney"],
  },
  contact_section: {
    eyebrow: "Start a conversation",
    title_lines: ["Let’s make your", "property shine."],
    text: "Tell us a little about what you need. We’ll be in touch to chat through the job and arrange a time to take a look.",
    form_title: "Request a quote",
    footnote: "No obligation. We’ll respond as soon as we can.",
  },
  footer: { text: "Property care for Sydney, with a local touch.", copyright: "© 2026 BVC Property Services" },
};

export const mediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

export const mergeContent = (defaults, saved) => {
  if (Array.isArray(defaults) || typeof defaults !== "object" || defaults === null) return saved ?? defaults;
  const merged = { ...defaults, ...(saved || {}) };
  Object.keys(defaults).forEach((key) => {
    if (typeof defaults[key] === "object" && defaults[key] !== null && !Array.isArray(defaults[key])) {
      merged[key] = mergeContent(defaults[key], saved?.[key]);
    }
  });
  return merged;
};
